<template>
    <div class="viewJURIS" v-if="dados">
        <div class="modal-conteudo m-2">
            <div id="divImprimir">
                <div class="row mb-2">
                    <div class="col-md-4">
                        <h6 >Acórdão:</h6>
                        <span class="regular">{{dados.nrAcordao}}/{{dados.nrAnoAcordao}} - {{dados.nmColegiado}}</span>
                    </div>
                    <div class="col-md-4">
                        <h6 >Data da sessão:</h6>
                        <template v-if="dados.dtSessaoFormatada == null || dados.dtSessaoFormatada == ''">
                            <span class="regular">...</span>
                        </template>
                        <template v-else>
                            <span class="regular" v-html="dados.dtSessaoFormatada"></span>
                        </template>
                    </div>
                    <div class="col-md-4">
                        <h6 >Relator:</h6>
                        <span class="regular" v-html="dados.nmAutores"></span>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-4">
                        <h6 >Área:</h6>
                        <span class="regular" v-html="dados.dsArea"></span>
                    </div>
                    <div class="col-md-4">
                        <h6 >Tema:</h6>
                        <span class="regular" v-html="dados.dsTema"></span>
                    </div>
                    <div class="col-md-4">
                        <h6 >Subtema:</h6>
                        <span class="regular" v-html="dados.dsSubTema"></span>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Outros indexadores:</h6>
                        <template v-if="dados.dsIndexacao == null || dados.dsIndexacao == ''">
                            <span class="regular">...</span>
                        </template>
                        <template v-else>
                            <span class="regular" v-html="dados.dsIndexacao"></span>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Tipo do processo:</h6>
                        <template v-if="dados.nmTipoProcesso == null || dados.nmTipoProcesso == ''">
                            <span class="regular">...</span>
                        </template>
                        <template v-else>
                            <span class="regular" v-html="dados.nmTipoProcesso"></span>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Enunciado:</h6>
                        <template v-if="dados.dsEnunciado == null || dados.dsEnunciado == ''">
                            <span class="regular">...</span>
                        </template>
                        <template v-else>
                            <span class="regular" v-html="dados.dsEnunciado"></span>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Excerto:</h6>
                        <template v-if="dados.dsExcerto == null || dados.dsExcerto == ''">
                            <span class="regular">...</span>
                        </template>
                        <template v-else>
                            <span class="regular" v-html="dados.dsExcerto"></span>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12" v-if="dados.dsPublicado == null || dados.dsPublicado == ''">
                        <h6 >Publicado:</h6>
                        <template v-if="dados.dsPublicado == null || dados.dsPublicado == ''">
                                <span class="regular">...</span>
                            </template>
                            <template v-else>
                                <span class="regular" v-html="dados.dsPublicado"></span>
                            </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Enunciados relacionados:</h6>
                        <template v-if="dados.dsEnunciado == null || dados.dsEnunciado == ''">
                            <span class="regular">...</span>
                        </template>
                        <template v-else>
                            <span class="regular" v-html="dados.dsEnunciado"></span>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        

        <div class="modal-footer pb-0 mt-4 d-flex justify-content-end">
            <button class="btn-default bg-solid-primary txt-size-14" @click="imprimir">
                <i class="fas fa-print"></i> Imprimir
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'viewJURIS',
        components: { },
        data: function () {
            return {
                tpConteudo: 'Pesquisa',
                cdConteudo: 'JURIS',
            }
        },
        props: {
            dados: Object,
        },
        methods: {
            imprimir() {
                var conteudo = document.getElementById('divImprimir').innerHTML,
                    tela_impressao = window.open('about:blank');

                tela_impressao.document.write(conteudo);
                tela_impressao.window.print();
                tela_impressao.window.close();
            },
        },
        mounted: function () {
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    
   
</style>

